import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

const CollectionDetails = () => {
  const { artistDocId, collectionId } = useParams();
  const navigate = useNavigate();
  const [collection, setCollection] = useState(null);
  const [artist, setArtist] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        // Récupérer la collection
        const collectionRef = doc(db, "artists", artistDocId, "collections", collectionId);
        const collectionSnap = await getDoc(collectionRef);

        if (collectionSnap.exists()) {
          setCollection(collectionSnap.data());
        } else {
          setError("Collection non trouvée");
        }

        // Récupérer les informations de l'artiste
        const artistRef = doc(db, "artists", artistDocId);
        const artistSnap = await getDoc(artistRef);
        if (artistSnap.exists()) {
          setArtist(artistSnap.data());
        }
      } catch (err) {
        console.error("Erreur lors de la récupération de la collection:", err);
        setError("Erreur lors du chargement des données");
      } finally {
        setIsLoading(false);
      }
    };

    if (artistDocId && collectionId) {
      fetchCollection();
    }
  }, [artistDocId, collectionId]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#00263a]">
        <Header />
        <div className="container mx-auto px-4 py-8 max-w-6xl">
          <div className="flex items-center justify-center min-h-[400px]">
            <p className="text-white text-xl">Chargement...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !collection) {
    return (
      <div className="min-h-screen bg-[#00263a]">
        <Header />
        <div className="container mx-auto px-4 py-8 max-w-6xl">
          <div className="bg-red-800 rounded-lg shadow-md p-6 mb-6">
            <p className="text-white text-xl">{error || "Collection non trouvée"}</p>
            <button
              onClick={() => navigate("/create-collection")}
              className="mt-4 bg-[#33c7b6] hover:bg-[#2ab3a3] text-[#00263a] px-6 py-2 rounded-full font-semibold"
            >
              Retour à la création
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#00263a]">
      <Header />
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-white">
            Collection créée avec succès !
          </h1>
          <button
            onClick={() => navigate("/create-collection")}
            className="bg-[#33c7b6] hover:bg-[#2ab3a3] text-[#00263a] px-6 py-2 rounded-full font-semibold"
          >
            Créer une autre collection
          </button>
        </div>

        {/* Informations de base */}
        <div className="bg-gray-800 rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-bold text-white mb-4">Informations de base</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-1">
                Nom de la collection
              </label>
              <p className="text-white font-semibold text-lg">{collection.name}</p>
            </div>
            {artist && (
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Artiste
                </label>
                <p className="text-white">
                  {artist.artistId ? artist.artistId.replaceAll("-", " ") : `${artist.firstName} ${artist.lastName}`}
                </p>
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-1">
                Artist ID
              </label>
              <p className="text-white font-mono text-sm">{collection.artistId}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-1">
                Année de production
              </label>
              <p className="text-white">{collection.yearOfProd}</p>
            </div>
            {collection.creationTime && (
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Date de création
                </label>
                <p className="text-white">
                  {collection.creationTime?.toDate
                    ? collection.creationTime.toDate().toLocaleString("fr-FR")
                    : new Date(collection.creationTime).toLocaleString("fr-FR")}
                </p>
              </div>
            )}
            {collection.description && (
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Description
                </label>
                <div className="bg-gray-700 rounded-md p-4">
                  <p className="text-white whitespace-pre-wrap">{collection.description}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Image de couverture */}
        {collection.coverPicture && (
          <div className="bg-gray-800 rounded-lg shadow-md p-6 mb-6">
            <h2 className="text-xl font-bold text-white mb-4">Image de couverture</h2>
            <div>
              <img
                src={collection.coverPicture}
                alt={collection.name}
                className="w-full max-w-2xl h-auto rounded-md"
              />
            </div>
          </div>
        )}

        {/* Bouton retour */}
        <div className="flex justify-center">
          <button
            onClick={() => navigate("/create-collection")}
            className="bg-[#33c7b6] hover:bg-[#2ab3a3] text-[#00263a] px-8 py-3 rounded-full font-semibold transition-colors"
          >
            Créer une autre collection
          </button>
        </div>
      </div>
    </div>
  );
};

export default CollectionDetails;

